import { Reducer } from 'redux'
import { OrderState, OrderTypes, OrderActionTypes } from './types'

const initialState: OrderState = {
  orders: { items: [] }
}

type ReducerOpts = Reducer<OrderState, OrderActionTypes>
const reducer: ReducerOpts = (state = initialState, action: OrderActionTypes): OrderState => {
  switch (action.type) {
    case OrderTypes.ORDER_GET:
      return {
        ...state,
        order: action.payload
      }
    case OrderTypes.ORDER_LIST:
      return {
        ...state,
        orders: { items: action.payload, pagination: action.pagination }
      }
    default:
      return state
  }
}

export default reducer
